import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';
import { IBuiltCar } from '../../../../../common/model/IBuiltCar';
import { AppDispatch } from '../../../common/store';
import useGetPostCode from '../../../common/react/useGetPostCode';

const useChangedCarDetails = (changeAction: (car: IBuiltCar) => void) => {
  const storeCustomisedCar = useSelector(carConfigurationSelectors.getCustomisedCar);
  const dispatch: AppDispatch = useDispatch();
  const postcode = useGetPostCode();

  useEffect(() => {
    // TODO there is an issue when we are in the scenario with an out of date dealer id.
    // TODO this hook will get executed after the dealer submission, if a different post code is used
    // TODO therefore two init calls will be made.
    // TODO please fix, at the time of writing I didn't know how to solve it with given the time constraints.
    if (storeCustomisedCar) {
      changeAction(storeCustomisedCar);
    }
  }, [dispatch, postcode]);
};

export default useChangedCarDetails;
